import React, { useEffect, useState } from 'react'
import Icon from 'src/components/Icons'

import { optimizelyFeatureFlags } from '../../constants/optimizely'
import { useOptimizely } from '../UserAnalytics/hooks/useOptimizely'


const GATSBY_ENV = process.env.GATSBY_ENV
const isLocal = GATSBY_ENV === 'local'

const GnattaWeb: React.FC = () => {
  const [enableRender, setEnableRender] = useState(false)
  const gnattaWebchatDecision = useOptimizely(optimizelyFeatureFlags.GNATTA_WEB_CHAT)

  useEffect(() => {
    if (gnattaWebchatDecision.enabled && !isLocal) {
      setEnableRender(true)
    }
  }, [gnattaWebchatDecision.enabled])

  if (!enableRender) {
    return null
  }

  return (
    <>
      <button
        id="gwc-chatAvailable"
        type="button"
        className="btn btn-success hidden gnatta-button"
      >
          Chat Available
        <Icon variant="advice" />
      </button>
      <button id="gwc-chatBusy" type="button" className="btn btn-warning hidden gnatta-button">
          Chat Busy
        <Icon variant="advice" />
      </button>
      <button id="gwc-chatOffline" type="button" className="btn btn-danger hidden gnatta-button">
          Chat Offline
        <Icon variant="advice" />
      </button>
    </>
  )
}

export default GnattaWeb
